import { DP_IDENTIFIER } from '@nykaa/nes-seo/constants';
import PageTypes from 'constants/pageTypes';
import { interactionLocation } from 'shared/constants';
import { GamoogaNotifRestriction } from './types';
import { isValidString } from '@nykaa/nes-utils/validations';
import { trackingParams } from 'constants/queryParams';

export const getPageType = (pathName: string) => {
  let currentPageType = '';
  if (pathName === '/') {
    currentPageType = PageTypes.HOME;
  }
  if (pathName && pathName.indexOf('/p/') > -1) {
    currentPageType = PageTypes.PRODUCT;
  } else if (pathName && pathName.indexOf('/c/') > -1) {
    currentPageType = PageTypes.LISTING;
  } else if (pathName && pathName.indexOf('/top-bestsellers-ranked/') > -1) {
    currentPageType = PageTypes.BESTSELLER_LISTING;
  } else if (pathName && pathName.indexOf('/search/result/') > -1) {
    currentPageType = PageTypes.SEARCH_LISTING;
  } else if (pathName && pathName.indexOf('/offer-products/') > -1) {
    currentPageType = PageTypes.OFFER_LISTING;
  } else if (pathName && pathName.indexOf(DP_IDENTIFIER) > -1) {
    currentPageType = PageTypes.DYNAMIC_PAGE;
  } else if (pathName && pathName.indexOf('/hlp/') > -1) {
    currentPageType = PageTypes.HLP;
  } else if (pathName && pathName.indexOf('/wishlist/') > -1) {
    currentPageType = PageTypes.WISHLIST;
  } else if (pathName && pathName.indexOf('/src/') > -1) {
    currentPageType = PageTypes.SRC_PAGE;
  } else if (pathName && pathName.indexOf('/sp/') > -1) {
    currentPageType = PageTypes.SP_PAGE;
  } else if (pathName && pathName.indexOf('/shoppingBag') > -1) {
    currentPageType = PageTypes.SHOPPING_BAG;
  }
  return currentPageType;
};

export const shouldShowGamoogaNotifiction = (
  config: GamoogaNotifRestriction
) => {
  if (!config.status) {
    return true;
  }
  let status = true;
  if (typeof window !== 'undefined') {
    const currUrl = window.location.href;
    if (config?.data?.some((url) => currUrl?.includes(url))) {
      status = false;
    }
  }
  return status;
};

export const authPageInteractionLocation = (pageType = '', source = '') => {
  let location = interactionLocation.otherPage;
  if (pageType === PageTypes.HOME) {
    location = interactionLocation.homePage;
  }
  if (pageType === PageTypes.PRODUCT) {
    location = interactionLocation.productPage;
  }
  if (pageType === PageTypes.LISTING) {
    location = interactionLocation.productListingPage;
  }
  if (pageType === PageTypes.SEARCH_LISTING) {
    location = interactionLocation.searchListingPage;
  }
  if (pageType === PageTypes.WISHLIST) {
    location = interactionLocation.wishlistPage;
  }
  if (isValidString(source)) {
    return `${location}:${source}`;
  }
  return location;
};

export const getInteractionLocation = (pageType = '') => {
  let location = '';
  if (pageType === PageTypes.HOME) {
    location = interactionLocation.homePage;
  }
  if (pageType === PageTypes.PRODUCT) {
    location = interactionLocation.productPage;
  }
  return location;
};

export const hasUTMParams = () => {
  const pdUrl = new URL(window.location.href);
  const queryParams = pdUrl.searchParams;
  const { UTM_SOURCE, UTM_MEDIUM, UTM_CAMPAIGN } = trackingParams;
  const utmParams = [UTM_SOURCE, UTM_MEDIUM, UTM_CAMPAIGN];
  return utmParams.some((param) => queryParams.has(param));
};

export const getFillColor = (
  headerTextColor?: string,
  isThemeHeader?: boolean,
  theme?: any
): string => {
  if (headerTextColor) {
    return headerTextColor;
  } else if (isThemeHeader) {
    return theme.colors.surface;
  } else {
    return theme.colors.surfaceInverse50;
  }
};

export const getBgColor = (themeBg: string, headerBg?: string): string => {
  if (headerBg) {
    return headerBg;
  } else {
    return themeBg;
  }
};

export const getStyles = (
  isLight: boolean,
  headerTextColor?: string,
  headerBg?: string,
  colors?: any
): string => {
  if (headerTextColor) {
    return `
      color: ${headerBg};
      background: ${headerTextColor};
      border-color: ${headerBg};
    `;
  } else if (isLight) {
    return `
      color: ${colors.primary40};
      background: ${colors.surface};
      border-color: ${colors.primary40};
    `;
  } else {
    return '';
  }
};

export const getWrapperBgColor = (
  theme: any,
  isThemeHeader?: boolean,
  headerBg?: string
): string => {
  if (headerBg) {
    return headerBg;
  } else if (isThemeHeader) {
    return theme.colors.primary40;
  } else {
    return theme.colors.surface;
  }
};

export const getSvgStyles = (
  theme: any,
  isLight?: boolean,
  color?: string
): string => {
  if (color) {
    return `
      circle {
        fill: ${color};
      }
      path {
        stroke: ${color};
      }
    `;
  } else if (isLight) {
    return `
      circle {
        fill: ${theme.colors.surface};
      }
      path {
        stroke: ${theme.colors.surface};
      }
    `;
  }
  return '';
};

export const getIconStyles = (
  theme: any,
  isLight?: boolean,
  color?: string
): string => {
  if (color) {
    return `
      circle {
        fill: ${color};
      }
    `;
  } else if (isLight) {
    return `
      circle {
        fill: ${theme.colors.surface};
      }
    `;
  }
  return '';
};

export const getStrokeColor = (
  theme: any,
  isLight?: boolean,
  color?: string
): string => {
  if (color) {
    return color;
  } else if (isLight) {
    return theme.colors.surface;
  } else {
    return theme.colors.surfaceInverse50;
  }
};

export const getPathStyles = (
  isLight?: boolean,
  color?: string,
  theme?: any
): string => {
  if (color) {
    return `
      path {
        fill: ${color};
      }
    `;
  } else if (isLight) {
    return `
      path {
        fill: ${theme.colors.surface};
      }
    `;
  }
  return '';
};

export const getSvgFillColor = (
  isThemeHeader?: boolean,
  color?: string,
  colors?: any
): string => {
  if (color) {
    return color;
  } else if (isThemeHeader) {
    return colors.surface;
  } else {
    return colors.primary;
  }
};
